var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLTabs",
    { staticClass: "guideline-tabs-outer", attrs: { defaultActiveKey: 1 } },
    [
      _vm._l(_vm.tabArray, function (tab) {
        return [
          _c(
            "a-tab-pane",
            { key: tab.tabId, attrs: { tab: tab.tabName } },
            [
              _c("HkldLetter", {
                ref: tab.tabType,
                refInFor: true,
                attrs: {
                  id: "guideline_" + tab.tabType,
                  type: tab.tabType,
                  isLineOrderEditable: tab.isLineOrderEditable,
                  validateDuplicate: tab.validateDuplicate,
                  resetDuplicate: tab.resetDuplicate,
                  publishHint: tab.publishHint,
                  onlyLine: tab.onlyLine,
                },
              }),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }